import {Maybe} from '@coolcolduk/typescript-util';
import {Box} from '@mui/material';
import statusNoteFormatter from './statusNoteFormatter';

export interface StatusNoteSectionProps {
  statusNote?: Maybe<string>;
}

export default function StatusNoteSection({statusNote}: StatusNoteSectionProps) {
  return (
    <Box
      component="pre"
      sx={{
        p: 2,
        bgcolor: 'grey.100',
        borderRadius: 1,
        overflow: 'auto',
        maxHeight: '60vh',
        fontFamily: 'monospace',
        fontSize: '0.875rem',
        whiteSpace: 'pre',
        wordBreak: 'normal',
        margin: 0,
      }}
      data-testid="status-note-section"
    >
      {statusNoteFormatter(statusNote)}
    </Box>
  );
}
